import { createContext, ReactNode, useState } from 'react';
import { SensorsStore } from './sensors-store';
import { useIntegratedSensors } from './use-integrated-sensors';
import { useSensorsEnabled } from './use-sensors-enabled';

export const SensorsStoreContext = createContext<SensorsStore | undefined>(undefined);

/**
 * Provides the sensor store everywhere, and connects it to the server only where sensors are on.
 * Sensors are a dispatch-side feature, so First Responder clients and users with the flag off
 * never mount `IntegratedSensors`: no `sensorAlert` subscription and no sensor query. Gating by
 * mounting matters because `useIntegratedStreams` subscribes the socket to its streams even when
 * it is disabled.
 */
export function SensorsProvider({ children }: { children: ReactNode }): React.ReactElement {
    const sensorsEnabled = useSensorsEnabled();
    const store = useState(() => new SensorsStore())[0];

    return (
        <SensorsStoreContext.Provider value={store}>
            {sensorsEnabled ? <IntegratedSensors store={store} /> : undefined}
            {children}
        </SensorsStoreContext.Provider>
    );
}

function IntegratedSensors({ store }: { store: SensorsStore }): null {
    useIntegratedSensors({ store });
    return null;
}
